<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
            placeholder="Search API Docs..."
            append-icon="mdi-magnify"
            solo
            dense
            small
            v-model="filterText"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="(doc, index) in filteredDocs"
          :key="index"
        >
          <v-card
            @click="handleClickDocument(doc.service_name)"
            class="api-card"
          >
            <v-row justify="center" align="center" style="height: 100%;">
              <v-col cols="12">
                <div class="title">
                  <b>{{ doc.title }}</b>
                </div>
              </v-col>
              <!-- <v-layout class="api-icon" align-center justify-center>
              <img
                :src="
                  doc.icon ||
                    'https://cdn.orb.ee/branding/orbee/corporate/RoundelLogo_White.png'
                "
                width="40"
                height="40"
              />
            </v-layout> -->
              <v-col cols="12">
                <div class="card-text">
                  {{ doc.description }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "DocumentList",
  props: {
    documents: {
      type: Array,
      default: () => {
        return [
          {
            name: "",
            description: "",
            icon: "",
            swaggerUrl: ""
          }
        ];
      }
    }
  },
  data() {
    return {
      filterText: ""
    };
  },
  computed: {
    filteredDocs() {
      // TODO (Nick) : Add debounce here
      if (!this.filterText) return this.documents;
      let srch = this.filterText.toLowerCase();
      let docs = [];

      docs = this.documents.filter(doc => {
        return (
          doc.title.toLowerCase().indexOf(srch) > -1 ||
          doc.spec_url.toLowerCase().indexOf(srch) > -1
        );
      });

      return docs;
    }
  },
  methods: {
    handleClickDocument(serviceName) {
      this.$emit("select-document", serviceName);
    }
  }
};
</script>

<style>
.api-card {
  margin: 10px;
  padding: 18px;
  height: 180px;
  text-overflow: ellipsis;
  text-align: center;
  overflow: hidden;
  background-color: #3d3d3d !important;
  color: #fff !important;
}

.api-card .api-icon {
  height: 50px;
  margin: 5px;
}

.api-card .title {
  color: #6f9bff;
}

.api-card .card-text {
  text-overflow: ellipsis;
  max-height: 50px;
  overflow: hidden;
}
</style>
